<template>
    <section>
        <row>
            <column lg="2" md="3">
                <div>
                    <div class="whitespace-nowrap">
                        {{
                            trans('stakeholders.overview.assets_count.label', {
                                count: maintainer.assetsCount || 0,
                            })
                        }}
                    </div>
                    <div class="whitespace-nowrap">
                        {{
                            trans('stakeholders.overview.locations_count.label', {
                                count: maintainer.topLevelLocationsCount || 0,
                            })
                        }}
                    </div>
                    <hr class="md:hidden" />
                </div>
            </column>
            <column>
                <stakeholder-contact-list :title="trans('maintainers.overview.contacts.title')" :contacts="maintainer.businessContacts" />
            </column>
        </row>
    </section>
</template>
<script setup>
import Column from '@/Components/Column.vue';
import StakeholderContactList from '@/Pages/Stakeholders/Components/StakeholderContactList.vue';

defineProps({ maintainer: Object });
</script>
